import type { SVGProps } from 'react';

export const AsucLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="34"
    viewBox="0 0 100 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#asuc_clip)">
      <path d="M27.3468 0H26.2514V33.1307H27.3468V0Z" fill="currentColor" />
      <path d="M17.3904 23.75H0V27.4593H17.3904V23.75Z" fill="#3EB9C0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7684 17.313C20.5636 17.313 19.5877 18.2889 19.5877 19.4937C19.5877 20.6984 20.5636 21.6744 21.7684 21.6744C22.9731 21.6744 23.9491 20.6984 23.9491 19.4937C23.9491 18.2889 22.9731 17.313 21.7684 17.313ZM12.7637 7.42515C11.6186 6.14192 10.0281 5.49976 7.99441 5.49976C6.49345 5.49976 5.13506 5.83576 3.92146 6.50666C2.70676 7.17867 1.75401 8.13584 1.06322 9.38039C0.371312 10.6238 0.0253601 12.0662 0.0253601 13.7053C0.0253601 15.3445 0.371312 16.7857 1.06211 18.0303C1.52301 18.8592 2.09997 19.5622 2.79298 20.1369C4.28952 18.9267 5.47438 18.1972 7.41856 18.0668C6.55313 17.933 5.81812 17.5517 5.20469 16.9195C4.43431 16.1193 4.04968 15.0483 4.04968 13.7053C4.04968 12.3624 4.43431 11.2903 5.20469 10.4912C5.97507 9.69207 6.95214 9.29196 8.13699 9.29196C9.32185 9.29196 10.2702 9.69207 11.0395 10.4912C11.8098 11.2914 12.1945 12.3624 12.1945 13.7053C12.1945 15.0483 11.8087 16.1193 11.0395 16.9195C10.4183 17.565 9.6678 17.9496 8.78911 18.0745C11.4108 18.2812 14.4968 19.581 16.1248 21.6744H17.3849V5.73629H12.7637V7.42515Z"
        fill="currentColor"
      />
      <path
        d="M82.3576 23.6695C82.7256 23.6695 83.0616 23.7611 83.4441 24.0054V24.6191C83.0933 24.301 82.747 24.1448 82.3852 24.1448C81.6657 24.1448 81.1616 24.8167 81.1616 25.596C81.1616 26.3752 81.6447 26.9721 82.2272 26.9721C82.6947 26.972 83.0361 26.5929 83.0362 26.079V25.9761H82.0226V25.4888H83.5502V27.4218H83.0771L83.0351 26.9776C82.7621 27.3246 82.4736 27.4815 82.1166 27.4815C81.3032 27.4815 80.6145 26.6747 80.6145 25.6512C80.6145 24.5415 81.3341 23.6695 82.3576 23.6695Z"
        fill="currentColor"
      />
      <path
        d="M88.0774 26.0447C88.0774 26.6238 88.3559 27.0029 88.9019 27.0029C89.4479 27.0029 89.7475 26.5918 89.7475 26.0447V23.7269H90.2514V26.1155C90.2514 26.982 89.7585 27.4804 88.892 27.4804C88.0254 27.4804 87.5745 26.993 87.5745 26.1099V23.7269H88.0774V26.0447Z"
        fill="currentColor"
      />
      <path
        d="M68.8997 23.6672C69.2357 23.6672 69.5397 23.7435 69.9597 23.9701V24.5934C69.6181 24.2961 69.2457 24.1436 68.9042 24.1436C68.4842 24.1436 68.1691 24.3823 68.1691 24.6686C68.1691 24.9548 68.3792 25.0964 68.9727 25.2368C69.7231 25.4158 70.1697 25.6921 70.1697 26.3033C70.1697 26.9963 69.5496 27.4783 68.7991 27.4783C68.4001 27.4783 68.0431 27.3588 67.6175 27.077V26.4437C68.032 26.7908 68.4476 26.9852 68.8466 26.9852C69.2456 26.9852 69.6237 26.6979 69.6237 26.363C69.6236 26.0977 69.4556 25.9032 68.8158 25.7407C68.3173 25.6158 67.6242 25.4102 67.6242 24.7283C67.6243 24.0463 68.1647 23.6672 68.8997 23.6672Z"
        fill="currentColor"
      />
      <path
        d="M38.4858 24.2199H37.4457V27.4208H36.9417V24.2199H35.8762V23.7324H38.4858V24.2199Z"
        fill="currentColor"
      />
      <path d="M42.7643 27.4208H42.2603V23.7269H42.7643V27.4208Z" fill="currentColor" />
      <path
        d="M44.2763 26.9333H46.0558V27.4208H43.7724V23.7269H44.2763V26.9333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.1719 23.7269C51.1224 23.7269 51.758 24.5017 51.758 25.46C51.758 25.9197 51.622 26.5266 51.2385 26.8736C50.908 27.1765 50.4924 27.4207 49.9254 27.4208H48.6654V23.7269H50.1719ZM49.1693 26.9333H49.8525C50.6394 26.9333 51.1909 26.3696 51.1909 25.5086C51.1909 24.7781 50.7079 24.2144 50.0989 24.2144H49.1693V26.9333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.134 23.7214C57.8005 23.7214 58.2106 24.0729 58.2106 24.6476C58.2106 25.0975 57.953 25.4059 57.3285 25.6225V25.6335C57.5861 25.7098 57.764 25.8988 57.89 26.2459L58.3199 27.4208H57.7584L57.4325 26.4404C57.2954 26.0347 57.1064 25.8126 56.724 25.8126H56.199V27.4208H55.6949V23.7225H57.1329L57.134 23.7214ZM56.2 25.323H56.609V25.3241C57.344 25.3241 57.6645 25.1395 57.6645 24.7117C57.6645 24.3702 57.3705 24.2077 56.987 24.2077H56.2V25.323Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.8066 27.4208H63.2186L62.8616 26.3265H61.5706L61.2136 27.4208H60.6311L61.9486 23.7269H62.4626L63.8066 27.4208ZM61.722 25.8392H62.6991L62.2105 24.3823H62.1995L61.722 25.8392Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.9541 23.7214C66.6206 23.7214 67.0307 24.0729 67.0307 24.6476C67.0307 25.0975 66.7731 25.4059 66.1486 25.6225V25.6335C66.4061 25.7098 66.5841 25.8988 66.7101 26.2459L67.1401 27.4208H66.5786L66.2526 26.4404C66.1155 26.0347 65.9265 25.8126 65.5441 25.8126H65.0191V27.4208H64.5151V23.7225H65.953L65.9541 23.7214ZM65.0201 25.323H65.4302L65.4291 25.3241C66.1641 25.3241 66.4846 25.1395 66.4846 24.7117C66.4846 24.3702 66.1906 24.2077 65.8071 24.2077H65.0201V25.323Z"
        fill="currentColor"
      />
      <path d="M71.4507 27.4208H70.9466V23.7269H71.4507V27.4208Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.1917 27.4208H77.6038L77.2467 26.3265H75.9547L75.5977 27.4208H75.0152L76.3327 23.7269H76.8478L78.1917 27.4208ZM76.1072 25.8392H77.0832L76.5947 24.3823H76.5846L76.1072 25.8392Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.8358 23.7214C86.5023 23.7214 86.9124 24.0729 86.9124 24.6476C86.9124 25.0975 86.6549 25.4059 86.0304 25.6225V25.6335C86.288 25.7098 86.4659 25.8988 86.5919 26.2459L87.0219 27.4208H86.4604L86.1343 26.4404C85.9983 26.0347 85.8082 25.8126 85.4258 25.8126H84.9008V27.4208H84.3968V23.7225H85.8358V23.7214ZM84.902 25.323H85.312L85.3108 25.3241C86.0458 25.3241 86.3664 25.1395 86.3665 24.7117C86.3665 24.3702 86.0724 24.2077 85.6888 24.2077H84.902V25.323Z"
        fill="currentColor"
      />
      <path
        d="M41.4579 24.2144H39.6574V25.2488H41.3794V25.7143H39.6574V26.9322H41.4579V27.4197H39.1534V23.7258H41.4579V24.2144Z"
        fill="currentColor"
      />
      <path
        d="M54.8969 24.2144H53.0964V25.2488H54.8184V25.7143H53.0964V26.9322H54.8969V27.4197H52.5925V23.7258H54.8969V24.2144Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.9077 23.7214C74.5432 23.7214 74.9788 24.106 74.9788 24.7073C74.9787 25.4003 74.4482 25.817 73.7342 25.817H72.9627V27.4197H72.4587V23.7214H73.9077ZM72.9627 25.3296H73.6767C74.1387 25.3296 74.4382 25.1129 74.4382 24.7283C74.4382 24.3978 74.1708 24.2089 73.8558 24.2089H72.9627V25.3296Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.6024 23.7214C93.2379 23.7214 93.6734 24.1061 93.6734 24.7073C93.6734 25.4003 93.1429 25.817 92.4289 25.817H91.6573V27.4197H91.1534V23.7214H92.6024ZM91.6573 25.3296H92.3713C92.8333 25.3296 93.1329 25.1129 93.1329 24.7283C93.1329 24.3978 92.8654 24.2089 92.5504 24.2089H91.6573V25.3296Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.8729 23.7214C96.5084 23.7214 96.9439 24.1061 96.9439 24.7073C96.9439 25.4003 96.4134 25.817 95.6994 25.817H94.9278V27.4197H94.4239V23.7214H95.8729ZM94.9278 25.3296H95.6418C96.1038 25.3296 96.4034 25.1129 96.4034 24.7283C96.4034 24.3978 96.1359 24.2089 95.8209 24.2089H94.9278V25.3296Z"
        fill="currentColor"
      />
      <path
        d="M100 24.2144H98.1995V25.2488H99.9215V25.7143H98.1995V26.9322H100V27.4197H97.6954V23.7258H100V24.2144Z"
        fill="currentColor"
      />
      <path
        d="M83.4462 24.6211L83.4441 24.6222V24.6191C83.4448 24.6198 83.4455 24.6204 83.4462 24.6211Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5537 8.47401C38.9555 8.47401 37.3396 8.90175 36.2431 9.68207L37.2832 11.7069C38.0083 11.1311 39.1047 10.7774 40.1636 10.7774C41.7242 10.7774 42.4681 11.5025 42.4681 12.747H40.1636C37.1163 12.747 35.8707 13.9739 35.8707 15.739C35.8707 17.5041 37.2644 18.7675 39.6054 18.7675C41.0732 18.7675 42.1144 18.2845 42.6526 17.3737V18.6182H45.3661V12.9139C45.3661 9.88544 43.601 8.4729 40.5537 8.4729V8.47401ZM75.4496 18.7686C77.5496 18.7686 79.2031 17.839 79.9281 16.2419L77.68 15.015C77.1406 15.9811 76.3426 16.39 75.4319 16.39C73.9641 16.39 72.8124 15.3676 72.8124 13.6213C72.8124 11.8749 73.9641 10.8526 75.4319 10.8526C76.3426 10.8526 77.1417 11.2803 77.68 12.2275L79.9281 11.0195C79.2031 9.38475 77.5496 8.47401 75.4496 8.47401C72.1978 8.47401 69.8756 10.6105 69.8756 13.6213C69.8756 16.6321 72.1978 18.7686 75.4496 18.7686ZM65.0257 8.62322V13.566C65.0257 15.4052 64.0597 16.2607 62.7212 16.2607C61.3827 16.2607 60.6963 15.5179 60.6963 13.8457V8.62432H57.7972V14.2734C57.7972 17.3582 59.5623 18.7697 62.0713 18.7697C63.2981 18.7697 64.4123 18.3055 65.1749 17.4323V18.6216H67.9248V8.62432H65.0257V8.62322ZM51.3501 18.7686C54.3421 18.7686 56.0696 17.4489 56.0696 15.5909C56.0696 11.6517 50.0304 13.3052 50.0304 11.5964C50.0304 11.0758 50.5874 10.6669 51.8883 10.6669C52.7991 10.6669 53.7839 10.8526 54.7687 11.4107L55.7347 9.34828C54.7875 8.79122 53.2633 8.47511 51.8883 8.47511C48.9715 8.47511 47.2617 9.8125 47.2617 11.708C47.2617 15.7025 53.3009 14.028 53.3009 15.666C53.3009 16.2231 52.7991 16.5768 51.4617 16.5768C50.2349 16.5768 48.8787 16.1866 47.9867 15.6108L47.0207 17.692C47.9502 18.3055 49.659 18.7697 51.3501 18.7697V18.7686ZM40.3316 16.8177C39.3092 16.8177 38.6969 16.3347 38.6969 15.6097C38.6969 14.941 39.1246 14.4392 40.4808 14.4392H42.4692V15.4616C42.1343 16.3723 41.2987 16.8177 40.3327 16.8177H40.3316Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="asuc_clip">
        <rect width="100" height="33.1307" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
